/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Export_Aborted_ToastInputs */

const en_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle export was aborted`)
};

const fr_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export des sous-titres annule`)
};

const de_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Export der Untertitel wurde abgebrochen.`)
};

const it_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esportazione dei sottotitoli è stata interrotta`)
};

const ru_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров был прерван.`)
};

const es_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se canceló la exportación de subtítulos`)
};

const zh_cn2_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出已中止`)
};

const ja_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートが中止されました`)
};

const hi_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात रद्द कर दिया गया`)
};

const pt_pt2_iconik_publish_export_aborted_toast = /** @type {(inputs: Iconik_Publish_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A exportação de legendas foi cancelada.`)
};

/**
* | output |
* | --- |
* | "Subtitle export was aborted" |
*
* @param {Iconik_Publish_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_export_aborted_toast = /** @type {((inputs?: Iconik_Publish_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_export_aborted_toast(inputs)
	if (locale === "de") return de_iconik_publish_export_aborted_toast(inputs)
	if (locale === "it") return it_iconik_publish_export_aborted_toast(inputs)
	if (locale === "ru") return ru_iconik_publish_export_aborted_toast(inputs)
	if (locale === "es") return es_iconik_publish_export_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_export_aborted_toast(inputs)
	if (locale === "ja") return ja_iconik_publish_export_aborted_toast(inputs)
	if (locale === "hi") return hi_iconik_publish_export_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_export_aborted_toast(inputs)
	return en_iconik_publish_export_aborted_toast(inputs)
});